import React, { Component } from "react";
// import SearchFilter from "./SearchFilter";
import SearchBox from "components/SearchBox";
import {
  Dropdown,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  CardText,
} from "reactstrap";
import Button from "material-ui/Button";
import DatePicker from "react-datepicker";
import {filterRecords} from './filterFunction';
import "react-datepicker/dist/react-datepicker.css";
// import SearchBox from "../../components/SearchBox/index";

const numberCondition = [{
  type: '>',
  key: 'greater'
},
{
  type: '<',
  key: 'less'
},
{
  type: '=',
  key: 'equal'
}];

const stringCondition = [{
  type: 'contains',
  key: 'contains',
},
{
  type: 'is equals',
  key: 'equal',
}];

class FilterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnType: false,
      columnSelectedData: {},
      inputValue: '',
      conditionType: false,
      conditionText: {},
      filter: this.props.filter !== undefined && this.props.filter,
      date: new Date(),
    };
  }

  setColumnToggle = () => {
    this.setState({
      columnType: !this.state.columnType
    })
  }

  selectColumnType = (event) => {
    this.setState({
      columnSelectedData: event,
      conditionText: {}
    })

  }

  setConditionToggle = () => {
    this.setState({
      conditionType: !this.state.conditionType
    })
  }

  selectConditionText = (event) => {
    this.setState({
      conditionText: event
    })

  }

  addFilter = () => {
    let data = {
      condition: this.state.conditionText,
      value: this.state.inputValue === '' ? this.state.date : this.state.inputValue,
      key: this.state.columnSelectedData,
    }
    let filter = this.state.filter;
    // const isExist = filter.findIndex(
    //   (item) => item.key.id === data.key.id
    // );
    // const exist = isExist !== -1;
    // if (exist) {
    // filter.splice(isExist, 1, data);
    // }
    // else {
    filter.push(data);
    // }
    this.setState({
      filter,
      columnSelectedData: {},
      inputValue: '',
      conditionText: {},
    })
  }

  filterRecords = () => {
    let data = this.props.data.filteredData;
    let filterData = filterRecords(data, this.state.filter);
    this.props.setFilteredData(filterData);
  }

  removeAllFilter = () => {
    let data = this.props.data.filteredData;
    this.props.setFilteredData(data);
  }

  removeFilter = (data) => {
    let filter = this.state.filter;
    const isExist = filter.findIndex(
      (item) => item.key.id === data.key.id
    );
    const exist = isExist !== -1;
    if (exist) {
      filter.splice(isExist, 1);
    }
    this.setState({
      filter,
    })
  }


  setStartDate = (date) => {
    this.setState({
      date,
    })

  }
  render = () => {
    const { columnData } = this.props.data;
    let addButton = Object.keys(this.state.columnSelectedData).length === 0 || Object.keys(this.state.conditionText).length === 0 || (this.state.inputValue === '' && this.state.columnSelectedData.type !== 'date');
    let filterButton = this.state.filter.length > 0;
    return (
      <div
        className="modal fade"
        id="searchModalComponent"
        style={{ top: "25%" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-2 border-0">
              <div className="col-12">
                <div className="row">
                  <div className="col-9">
                    <h4 className="modal-title">Filter Results</h4>
                  </div>
                  <div className="col-3">
                    <div className="row">
                      <div className="d-flex align-items-center justify-content-end col-6">
                        <h5 className="mb-0 pl-2" />
                      </div>
                      <div className="d-flex align-items-center col-6 justify-content-end">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                        >
                          <h6 className="input-for-search">&times;</h6>
                          <h4 className="pl-1 modal-title">Close</h4>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="d-flex">
                <div className="col-12 d-flex justify-content-start align-items-center">
                  <Dropdown
                    isOpen={this.state.columnType}
                    toggle={this.setColumnToggle}
                  >
                    <DropdownToggle color="Secondary" caret className="mb-0">
                      {Object.keys(this.state.columnSelectedData).length === 0 ? "Select type" : this.state.columnSelectedData.label}
                    </DropdownToggle>
                    <DropdownMenu>
                      {columnData && columnData.length > 0 && columnData.map((data) => {
                        return (
                          <DropdownItem onClick={() => this.selectColumnType(data)}>
                            {data.label}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                  <Dropdown
                    isOpen={this.state.conditionType}
                    toggle={this.setConditionToggle}
                  >
                    <DropdownToggle color="Secondary" caret className="mb-0">
                      {Object.keys(this.state.conditionText).length === 0 ? "Select type" : this.state.conditionText.type}
                    </DropdownToggle>
                    <DropdownMenu>
                      {Object.keys(this.state.columnSelectedData).length > 0 && (this.state.columnSelectedData.type === 'number' || this.state.columnSelectedData.type === 'date') ?
                        numberCondition && numberCondition.length > 0 && numberCondition.map((data) => {
                          return (
                            <DropdownItem onClick={() => this.selectConditionText(data)}>
                              {data.type}
                            </DropdownItem>
                          );
                        }) : stringCondition && stringCondition.length > 0 && stringCondition.map((data) => {
                          return (
                            <DropdownItem onClick={() => this.selectConditionText(data)}>
                              {data.type}
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </Dropdown>
                  {this.state.columnSelectedData.type !== 'date' ?
                    <input
                      onChange={(e) => {
                        this.setState({
                          inputValue: e.target.value
                        })
                      }}
                      type="text"
                      placeholder=""
                      value={this.state.inputValue}
                    /> :
                    <DatePicker endDate={new Date()} selected={this.state.date} onChange={date => this.setStartDate(date)} />}
                  <Button
                    disabled={addButton}
                    onClick={async () => {
                      this.addFilter();
                    }}
                    variant="raised"
                    color={'primary'}
                    color={addButton ? "default" : "primary"}
                    className="jr-btn text-white mx-4"
                  >
                    Add
                      </Button>
                </div>
              </div>
              <div
                className="slimScrollDiv"
                style={{
                  position: "relative",
                  overflow: "overlay",
                  width: "auto",
                  height: "100%",
                }}
              >
                <div className="inner-height">
                  {this.state.filter.length > 0 ? (
                    <table className="table search-table mt-3 table-bordered">
                      <thead>
                        <tr>
                          <th>Key</th>
                          <th>Condition</th>
                          <th>Value</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.filter && this.state.filter.length > 0 &&
                          this.state.filter.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.key.label}</td>
                                <td>{item.condition.type}</td>
                                <td>{item.key.type === 'date' ? new Date(item.value).toString() : item.value}</td>
                                <td>
                                  <a onClick={() => {
                                    this.removeFilter(item);
                                    // this.props.onViewPitClick(el);
                                  }}
                                  >Remove</a>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  ) : (
                      <h3>Please select filters</h3>
                    )}
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-end">
                <Button
                  // disabled={!filterButton}
                  onClick={async () => {
                    this.removeAllFilter();
                  }}
                  variant="raised"
                  color={'primary'}
                  // color={!filterButton ? "default" : "primary"}
                  className="jr-btn text-white"
                >
                  Remove Filter
                      </Button>
                <Button
                  disabled={!filterButton}
                  onClick={async () => {
                    this.filterRecords();
                  }}
                  variant="raised"
                  // color={'primary'}
                  color={!filterButton ? "default" : "primary"}
                  className="jr-btn text-white"
                >
                  Filter
                      </Button>
              </div>
              {/* {this.state.showMoreDevices} */}
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default FilterModal;



// WEBPACK FOOTER //
// ./app/routes/filterModal/filterModal.js